module.exports = __webpack_public_path__ + "img/noteligible.1189b069.svg";